import {Button, useForkRef} from '@mui/material';
import PropTypes from 'prop-types';
import {DateRangePicker} from '@mui/x-date-pickers-pro';
import dayjs from 'dayjs';

import React, {forwardRef, useState} from 'react';

const DateRangeButtonField = forwardRef((props, ref) => {
    const {setOpen, label, id, disabled, InputProps: {ref: containerRef} = {}, inputProps: {'aria-label': ariaLabel} = {}} = props;

    const handleRef = useForkRef(ref, containerRef);

    return (
        <Button
            variant="outlined"
            id={id}
            disabled={disabled}
            ref={handleRef}
            aria-label={ariaLabel}
            onClick={() => setOpen?.((prev) => !prev)}
            sx={{
                backgroundColor: label ? 'secondary.main' : 'transparent',
                color: label ? 'white' : 'secondary.main',
                border: '1px solid rgba(20, 156, 224, 0.5)'
            }}
        >
            {label ? `${label}` : 'Custom date'}
        </Button>
    );
});

DateRangeButtonField.propTypes = {
    setOpen: PropTypes.func,
    label: PropTypes.string,
    id: PropTypes.string,
    disabled: PropTypes.bool,
    InputProps: PropTypes.object,
    inputProps: PropTypes.object
};

DateRangeButtonField.fieldType = 'single-input';

export const ButtonDateRangePicker = forwardRef((props, ref) => {
    const [open, setOpen] = useState(false);

    return (
        <DateRangePicker
            maxDate={dayjs()}
            slots={{field: DateRangeButtonField, ...props.slots}}
            slotProps={{field: {setOpen}}}
            ref={ref}
            {...props}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
        />
    );
});

ButtonDateRangePicker.propTypes = {
    ...DateRangePicker.propTypes
};
